// material-ui

import createexistingbookingicon from '../../../assets/images/create_booking-existing.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const CreateExistingBookingIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={createexistingbookingicon} alt="Create Booking" width="22"  />
    );
};

export default CreateExistingBookingIcon;